import React, { useRef } from 'react'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'
import Dropdown from '@/components/partials/Dropdown'

function Filter(props) {
    const categoryDropdownRef = useRef(null)
    const clientDropdownRef = useRef(null)

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('start_date', '')
        props.handleSearch('end_date', '')
        props.handleSearch('search', '')
        props.handleSearch('type_id', '')
        props.handleSearch('category_id', '')
        categoryDropdownRef.current.reset()
        props.handleSearch('customer_id', '')
        clientDropdownRef.current.reset()
    }

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('category_id', val)
        }

    }


    const handleCustomer = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('customer_id', val)
        }

    }


    return (
        <form className="filter-standard">
            <div className="col" data-id="3">
                <input
                    type="search"
                    name="search"
                    placeholder={trans('random.clientDocNo')}
                    className="field-big"
                    value={props.filter.search}
                    onChange={handleSearch}
                />
            </div>
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1">
                        {trans('filters.startDate')}
                    </option>
                    <option value="2">
                        {trans('filters.endDate')}
                    </option>
                    <option value="3">
                        {trans('filters.search')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">
                <select
                    name="type_id"
                    value={props.filter.type_id || ''}
                    onChange={handleSearch}
                >
                    <option value="">{trans('invoice.type')}</option>
                    <option value={1}>
                        {trans('invoice.proforma')}
                    </option>
                    <option value={2}>
                        {trans('invoice.invoice')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="2">
                <select
                    name="status"
                    value={props.filter.status || ''}
                    onChange={handleSearch}
                >
                    <option value="all">{trans('labels.status')}</option>
                    <option value="paid">{trans('tabs.paid')}</option>
                    <option value="unpaid">{trans('tabs.unpaid')}</option>
                    <option value="awaiting">{trans('tabs.awaitingPayment')}</option>
                </select>
            </div>

            <div className="col" data-id="3">
                <Dropdown
                    ref={categoryDropdownRef}
                    inputIdValue={Number(props.filter.customer_id)}
                    url="customers/with-invoices"
                    renderText={data => {
                        return data.full_name
                    }}
                    onChange={data => {
                        handleCustomer(data)
                    }}
                    inputPlaceholder={trans('labels.client')}
                />
            </div>

            <div className="col" data-id="4">
                <Dropdown
                    ref={clientDropdownRef}
                    inputIdValue={Number(props.filter.category_id)}
                    url="appliances/categories/all"
                    renderText={data => {
                        return data.name
                    }}
                    onChange={data => {
                        handleCategory(data)
                    }}
                    inputPlaceholder={trans('labels.category')}
                />
            </div>


            <div className="col" data-id="5">
                <DateRange
                    startDate={props.filter.start_date}
                    endDate={props.filter.end_date}
                    onStartDateChange={(date) => {
                        props.handleSearch('start_date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end_date', date)
                    }}
                />
            </div>

            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilter')}
                </button>
            </div>
        </form>
    )
}

export default React.memo(Filter, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})